import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Loader from '@components/Loader';
import Drawer from '../Drawer/Drawer';
import OrderOnCallButton from '../Button/OrderOnCallButton';
import LabCard from '../DiagnosticsCart/LabCard';
// import SelectSlot from '../PathlabSlots/SelectSlot';
import './PathlabPkgCard.scss';

class PathlabPkgCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      selectedLabID: -1,
      showDoneBtn: true,
      showTooltip: false,
      isCartLoading: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getPkgPrice = () => {
    const { product: { available_at }, labID } = this.props;
    if (labID > 0) {
      const selectedLab = available_at.find(lab => lab.item_id === Number(labID));
      return (
        <div className="textTitle">
          &#8377;{selectedLab.pe_selling_price}
          {Number(selectedLab.mrp) > Number(selectedLab.pe_selling_price) && (
            <span className="textSubtitleCancelled">
              &#8377;{selectedLab.mrp}
            </span>
          )}
          {Number(selectedLab.mrp) > Number(selectedLab.pe_selling_price) && (
            <span className="textGreen">
              {this.calculateDisc(
                selectedLab.mrp,
                selectedLab.pe_selling_price
              )}
              % Savings
            </span>
          )}
        </div>
      );
    }
    return 'Calculating test price';
  }

  calculateDisc = (mrp, prPrice) => Math.round(((mrp - prPrice) / mrp) * 100);

  toggleDrawer = () => {
    if (!this.state.openDrawer) {
      const { product, testDetails } = this.props;
      if (product.is_available) {
        this.setState({
          isCartLoading: true,
        });
        this.props.actions.addToDiagCart(this.props.labID, product.item_id, product.item_type).then(() => {
          this.props.actions.getDiagnosticsCart().then(() => {
            this.setState({
              isCartLoading: false,
            });
          });
        });
      } else if (product.is_available === false) {
        const testArray = [{ item_type: product.item_type, item_id: product.item_id }];
        testDetails.forEach(test => testArray.push({ item_type: test.item_type, item_id: test.item_id }));
        this.props.actions.getLabsAvailableToChangeSelectedLab(this.props.labID, testArray).then(() => {
          this.setState({
            showDoneBtn: false,
            openDrawer: !this.state.openDrawer,
          });
        });
      } else {
        this.props.actions.getAllAvailableLabs(product.item_id, product.item_type).then(() => {
          this.setState({
            showDoneBtn: true,
            openDrawer: !this.state.openDrawer,
          });
        });
      }
    }
  }

  showTooltipText = () => {
    this.setState({
      showTooltip: !this.state.showTooltip,
    });
  }

  handleClickOutside = () => {
    this.setState({
      showTooltip: false,
    });
  }

  selectLab = labID => {
    this.setState({
      selectedLabID: labID,
    });
  }

  closeDrawer = () => {
    this.setState({
      openDrawer: false,
    });
  }

  showAddBtn = () => {
    const { testDetails, product } = this.props;
    let result = true;
    testDetails.forEach(test => {
      /*
      * combination of master_id and product's item_type
      * needs to be unique, to say if sku is present of not
      */
      const isSkuPresentInCart = test.item_id === product.item_id && test.item_type === product.item_type;
      if (isSkuPresentInCart) {
        result = false;
      }
    });
    return result;
  }

  doneClick = () => {
    const labDetails = this.props.availableLabs.filter(lab => lab.item_id === this.state.selectedLabID);
    const { item_id, item_type } = this.props.product;
    if (labDetails.length > 0) {
      this.props.actions.setSelectedLab(labDetails[0]);
      if (this.state.showDoneBtn) {
        this.setState({
          isCartLoading: true,
        });
        this.props.actions.addToDiagCart(labDetails[0].item_id, item_id, item_type).then(() => {
          this.props.actions.clearDiagSearch();
          this.props.actions.getDiagnosticsCart().then(() => {
            this.setState({
              isCartLoading: false,
            });
            this.props.actions.searchDiagnosticsProducts(this.props.queryParams, labDetails[0].item_id);
          });
        });
      } else {
        this.props.actions.clearDiagSearch();
        this.props.actions.changeLab(labDetails[0].item_id).then(() => {
          this.setState({
            isCartLoading: true,
          });
          this.props.actions.addToDiagCart(labDetails[0].item_id, item_id, item_type).then(() => {
            this.props.actions.getDiagnosticsCart().then(() => {
              this.setState({
                isCartLoading: false,
              });
            });
          });
        });
      }
    }
    this.setState({
      openDrawer: !this.state.openDrawer,
    });
  }

  render() {
    const { product, availableLabs, unAvailableLabs, selectedLab, testDetails } = this.props;
    const { openDrawer, selectedLabID, showDoneBtn, showTooltip } = this.state;
    if (this.state.isCartLoading) {
      return <Loader />;
    }
    return (
      <div className="mainContainerPkg">
        <div className="imgContainer">
          <img src={product.item_type === 'package' ? require('../../images/labpkg.svg') : require('../../images/labtest.svg')} alt="x" />
        </div>
        <div className="detailsContainer">
          <div className="textContainer">
            <div className="textTitle">{product.item_name}</div>
            <div className="textSubtitle">{product.lab_availability}</div>
            <div className="textSubtitleGreen">{product.sub_text}
              <span className="testTooltipIcon" onClick={this.showTooltipText}>
                <img src={require('../../images/indicator.svg')} alt="i" />
              </span>
              {showTooltip && <div className="testToolTipText">
                {product.tests_included.profiles && product.tests_included.profiles.map(profile => profile.tests.map(test => <div key={test.item_id}>{test.name}</div>))}
                {product.tests_included.tests && product.tests_included.tests.map(test => <div key={test.item_id}>{test.name}</div>)}
              </div>}
            </div>
            {product.is_available ? this.getPkgPrice() : <div className="textTitle">&#8377;{product.starting_price}
              <span className="textSubtitle">Onwards</span>
            </div>}
          </div>
          {(Object.keys(product).includes('is_available') && !product.is_available) ?
            <div className="btnContainer">
              <OrderOnCallButton
                text="ADD"
                type={1}
                loading={false}
                disabled={!product.is_available}
              /></div> : (this.showAddBtn() ? <div className="btnContainer">
                <OrderOnCallButton
                  text="ADD"
                  type={1}
                  loading={false}
                  onClickFunction={this.toggleDrawer}
                />
              </div> : <div>Added in cart</div>)}
        </div>
        <Drawer open={openDrawer} onClose={this.closeDrawer}>
          {product.is_available === false && <div className="unavailableLabContainer">
            <div className="imgContainr"><img alt="lab" src={selectedLab.item_logo} /></div>
            <div className="textContainer">
              <div className="textTitle">{selectedLab.item_name}</div>
              {testDetails.map(test => <div className="availableTests" key={test.item_id}><span><img src={require('../../images/available.svg')} /></span>{test.item_name} is available</div>)}
              <div className="error"><span><img src={require('../../images/unavailable.svg')} /></span>{product.item_name} is unavailable</div>
            </div>
          </div>}
          <div className="labHeader">
            <img src={require('../../images/select-lab.svg')} alt="x" />
            {product.is_available === false ? 'Change Lab' : 'Select Lab'}
          </div>
          <div className="labsContainer">
            {availableLabs && availableLabs.map(lab => <LabCard key={lab.item_id} labDetails={lab} selectLab={this.selectLab} isSelected={lab.item_id === selectedLabID} />)}
            {unAvailableLabs && <div className="unavailableLab">
              <div className="unavailableLabWarning">{unAvailableLabs.warning_text}</div>
              <div className="unavailableLabGTCText">{unAvailableLabs.go_to_cart_text}</div>
            </div>}
          </div>
          <div className="doneContainer">
            <OrderOnCallButton
              text={showDoneBtn ? 'Done' : 'Change Lab'}
              type={1}
              loading={false}
              onClickFunction={this.doneClick}
              disabled={selectedLabID < 0}
            />
          </div>
        </Drawer>
      </div>
    );
  }
}

PathlabPkgCard.propTypes = {
  product: PropTypes.object,
  actions: PropTypes.object,
  availableLabs: PropTypes.array,
  unAvailableLabs: PropTypes.object,
  testDetails: PropTypes.array,
  labID: PropTypes.number,
  selectedLab: PropTypes.object,
  queryParams: PropTypes.string,
};

PathlabPkgCard.defaultProps = {
  product: {},
  actions: {},
  availableLabs: [],
  testDetails: [],
  labID: null,
  unAvailableLabs: {},
  selectedLab: {},
  queryParams: '',
};

export default connect(state => ({
  availableLabs: state.diagnosticsCart.availableLabs,
  unAvailableLabs: state.diagnosticsCart.unAvailableLabs,
  testDetails: state.diagnosticsCart.testDetails,
  selectedLab: state.diagnosticsCart.selectedLab,
  queryParams: state.product.searchQuery,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(PathlabPkgCard);
